var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3KredytyObrotowe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffcf5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #bec6c6;\n      }\n\n      .cls-3 {\n        fill: #1d1d1b;\n      }\n\n      .cls-4 {\n        fill: #ffa900;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11,
    cy: 32,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35,
    cy: 32,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23,
    cy: 11,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m11,43c-6.07,0-11-4.93-11-11s4.93-11,11-11,11,4.93,11,11-4.93,11-11,11Zm0-20c-4.96,0-9,4.04-9,9s4.04,9,9,9,9-4.04,9-9-4.04-9-9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m35,43c-6.07,0-11-4.93-11-11s4.93-11,11-11,11,4.93,11,11-4.93,11-11,11Zm0-20c-4.96,0-9,4.04-9,9s4.04,9,9,9,9-4.04,9-9-4.04-9-9-9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m24,16h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1-.45,1-1s-.45-1-1-1h-2c-1.65,0-3-1.35-3-3s1.35-3,3-3h4c.55,0,1,.45,1,1s-.45,1-1,1h-4c-.55,0-1,.45-1,1s.45,1,1,1h2c1.65,0,3,1.35,3,3s-1.35,3-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23,8c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23,18c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12,37h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1-.45,1-1s-.45-1-1-1h-2c-1.65,0-3-1.35-3-3s1.35-3,3-3h4c.55,0,1,.45,1,1s-.45,1-1,1h-4c-.55,0-1,.45-1,1s.45,1,1,1h2c1.65,0,3,1.35,3,3s-1.35,3-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11,29c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11,39c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m23,22c-6.07,0-11-4.93-11-11S16.93,0,23,0s11,4.93,11,11-4.93,11-11,11Zm0-20c-4.96,0-9,4.04-9,9s4.04,9,9,9,9-4.04,9-9S27.96,2,23,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m21.01,46c-.33,0-.65-.16-.84-.46l-1.54-2.37c-.3-.46-.17-1.08.29-1.38l2.37-1.54c.46-.3,1.08-.17,1.38.29.3.46.17,1.08-.29,1.38l-1.53,1,1,1.53c.44.67-.06,1.54-.84,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m19.28,43.63c-.54-.11-.89-.64-.78-1.18.11-.54.64-.89,1.18-.78,1.99.4,4.03.44,6.16.09.54-.09,1.06.28,1.15.83.09.54-.28,1.06-.83,1.15-2.33.38-4.61.35-6.88-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m37.19,18.35c-.49-.25-.69-.85-.44-1.34.25-.49.85-.69,1.35-.44l1.63.83.83-1.63c.25-.49.85-.69,1.35-.44.49.25.69.85.44,1.34-1.96,3.86-1.25,3.66-5.15,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.18,19.72c-.42,0-.81-.26-.95-.68-.67-2-1.68-3.77-3-5.38-.35-.43-.29-1.06.14-1.41.43-.35,1.06-.29,1.41.14,1.44,1.76,2.58,3.74,3.35,6.01.22.65-.26,1.32-.95,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m9.28,16.58c-.53,0-.97-.41-1-.95l-.1-1.83-1.83.1c-.55.02-1.02-.4-1.05-.95-.03-.55.39-1.02.95-1.05l2.82-.15c.55-.04,1.02.39,1.05.95l.15,2.82c.03.57-.42,1.05-1,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m5.76,19.36c-.7,0-1.18-.7-.94-1.35.83-2.19,1.99-4.16,3.53-5.9.37-.42,1-.46,1.41-.09.41.37.45,1,.09,1.41-1.37,1.56-2.42,3.32-3.16,5.29-.15.4-.53.65-.94.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36,37h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1-.45,1-1s-.45-1-1-1h-2c-1.65,0-3-1.35-3-3s1.35-3,3-3h4c.55,0,1,.45,1,1s-.45,1-1,1h-4c-.55,0-1,.45-1,1s.45,1,1,1h2c1.65,0,3,1.35,3,3s-1.35,3-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35,29c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35,39c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3KredytyObrotowe);
export default __webpack_public_path__ + "static/media/3-Kredyty-obrotowe.384d38715b34df3686985e9214f5dc62.svg";
export { ForwardRef as ReactComponent };